'use client';
import * as React from 'react';
import { AboutFounderHeader } from './AboutFounderHeader';
import { AboutFounderContent } from './AboutFounderContent';

function AboutFounder() {
	return (
		<section className='pb-16 rounded-none'>
			<div className='flex flex-col items-start md:px-22 px-10 pt-28 w-full bg-gray-100 rounded-[56px_56px_0px_0px] max-md:px-5 max-md:pt-24 max-md:max-w-full py-6'>
				<div className='flex z-10 flex-col mb-0 max-w-full w-7xl max-md:mb-2.5 md:px-7'>
					<AboutFounderHeader />
					<AboutFounderContent />
				</div>
			</div>
		</section>
	);
}

export default AboutFounder;
